import { cloneDeep } from 'lodash';
import Style from 'molo-shared/lib/models/Style';

import { Filter, initialFilter } from '../models/Filter';
import { FilterHelper } from './FilterHelper';

/**
 * Clears shop-only active filters so wishlist grid is not emptied by stale delivery/collection state,
 * then sets sustainability option list from loaded wishlist styles.
 */
export function buildWishlistGridFilter(styles: Style[], current?: Filter | null): Filter {
    const base = cloneDeep(current && current.activeFilters ? current : initialFilter);
    base.activeFilters = {
        seasons: [],
        collections: [],
        productGroups: [],
        productCategories: [],
        deliveryWindows: [],
        sustainability: [],
    };
    base.seasons = [];
    base.collections = [];
    base.productGroups = [];
    base.productCategories = [];
    base.deliveryWindows = [];
    base.sustainability = FilterHelper.hydrateSustainability(styles);
    return base;
}
